import React from 'react';
import kota2 from "../Asserts/kota2.png";
import { useNavigate } from 'react-router-dom';

function Second() {
  const navigate = useNavigate();
  
  const handleAboutclick = () => {
    navigate('/about');
  }

  return (
    <div className="flex flex-col md:flex-row items-center w-full px-6 py-10 bg-gradient-to-r from-[#f4f1de] to-[#FDFBF8] ">
      {/* Image Section */}
      <div className="w-full md:w-1/2 flex justify-center">
  <img
    src={kota2}
    className="w-full max-w-[300px] sm:max-w-[400px] md:max-w-[500px] lg:max-w-[700px] h-auto rounded-lg"
    alt="Why Choose Us"
  />
</div>

      {/* Text Content Section */}
      <div className="w-full md:w-1/2 flex flex-col gap-4 md:pl-10  md:text-left mt-6 md:mt-0">
        <h2 className="text-2xl font-semibold text-[#FF6F00] uppercase tracking-wide">
          Why Choose Us
        </h2>
        <h1 className="text-3xl font-bold text-[#FF6F00] leading-tight">
          Unlocking Opportunities for Your Financial Solutions
        </h1>
        <p className="text-gray-700 text-base sm:text-lg md:text-xl leading-relaxed">
          Our dedicated team of experts conducts thorough research and analysis to provide you with
          comprehensive and unbiased financial solutions. We are committed to delivering the best
          financial advice and service reviews of various loan and insurance products.
        </p>
        
        <ul className="space-y-2 text-gray-800 text-base sm:text-lg md:text-xl font-medium list-disc list-outside pl-5">
          <li>Exceptional Customer Service</li>
          <li>We prioritize your satisfaction; our dedicated customer service team is ready to assist.</li>
          <li>Extensive Network of Lenders</li>
          <li>We have strong partnerships with a wide network of reputable lenders.</li>
          <li>Unbiased and Transparent Approach</li>
          <li>Transparency and objectivity are at the core of our services.</li>
          <li>Expertise and Knowledge</li>
          <li>Our team consists of financial experts with deep industry knowledge.</li>
        </ul>
      
        <button
          onClick={handleAboutclick}
          className="bg-[#FF6F00] text-white px-6 py-3 text-base sm:text-lg rounded-lg shadow-md hover:bg-[#E65C00] transition duration-300 w-full sm:w-auto self-center md:self-start"
        >
          Learn More
        </button>
      </div>
    </div>
  );
}

export default Second;
